<template>
  <div>
    <el-dialog
      title="国开乐学授权码"
      :visible.sync="show"
      width="30%"
      :before-close="handleClose"
    >
      <el-input v-model.trim="authCode" placeholder="请输入内容"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="trueBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { BoundLexueCode } from "@/api/willingLearn/index.js";
export default {
  name: "boundCode",
  data() {
    return {
      authCode: "",
    };
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    resourceId: {
      type: String,
      default: "",
    },
  },
  methods: {
    handleClose() {
      this.authCode = "";
      this.$emit("close");
    },
    trueBtn() {
      if (this.authCode.replace(/\s+/g, "") != "") {
        if (this.authCode.replace(/\s+/g, "").length === 13) {
          BoundLexueCode({
            authCode: this.authCode.replace(/\s+/g, "").toLowerCase(),
            resourceId: this.resourceId,
          }).then((res) => {
            this.authCode = "";
            if (res.data === "授权成功，请前往书架查看") {
              this.$emit("succeed");
              this.$message.success(res.data);
            } else {
              this.$message(res.data);
            }
          });
        } else {
          this.$message("授权码长度应为13位");
        }
      } else {
        this.$message("请输入激活码");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>